import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"counsel_todo",
    list_id:"counsel_todo_cal_list",
    x_column_list_arr:[
      {"key":"a_reserve_date","name":"예약일","width":"100","is_show":"1"},
      // {"key":"a_counsel_date","name":"상담일","width":"100","is_show":"1"},
      {"key":"a_stu_name","name":"학생","width":"100","is_show":"1"},
      {"key":"row_view_stu_grade","name":"학년","width":"100","is_show":"1"},
      {"key":"row_view_stu_school","name":"학교","width":"100","is_show":"1"},
      {"key":"a_counseler","name":"선생님","width":"100","is_show":"1"},
      {"key":"row_view_state","name":"상태","width":"100","is_show":"1"},
      //{"key":"a_state","name":"상태","width":"100","is_show":"1"},
      {"key":"row_view_manage","name":"관리","width":"120","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':100,
      'order_id':'a_create_date DESC',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
      "s_class_seq":"",
      "s_school_name":"",
      "s_stu_grade":"",
      "s_stu_state":"now",
      "s_is_par_join":"",
      "s_search_text_type":"name",
      "s_search_text":"",
      "s_user_name_like":"",
      "s_phone_like":"",
      "s_stu_num_like":"",
      "s_school_name_like":"",
      "s_class_name_like":"",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_ymd","a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);
  xColumnArr.date_col_arr=["a_reserve_date"];

  return xColumnArr;
};

export default getXcolumnJson;